import { createContext } from "react";

const LanguageContext = createContext(null);

const SortimentContext = createContext(null);

const LocalesContext = createContext(null);

export { LanguageContext, SortimentContext, LocalesContext };
